import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, catchError, of } from 'rxjs';
import { WorkGroup } from 'src/app/shared/interfaces/chat';
import { environment } from "../../../environments/environment";

export interface UploadResponse {
  status: string;
  code: string;
  message: string;
  url: string;
}
@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private http: HttpClient) { }

  getContactInfo(phone: string, kcId: string, isoCode: string): Observable<any> {
    const params = new HttpParams()
      .set('phone', phone)
      .set('kcId', kcId)
      .set('isocode', isoCode);

    return this.http.get<any>(`${environment.url}/contact-management/api/contacts/getContactChat`, { params });
  }

  updateContactInfo(params: any): Observable<any> {
    return this.http.put<any>(`${environment.url}/contact-management/api/contacts/updateContact`, params);
  }

  getWabaId(accountUuid: string) {
    const params = new HttpParams().set('account_id', accountUuid);
    return this.http.get<any>(`${environment.url}/account-management/get-account-sumary-by-account-id`, { params });
  }

  getTemplatesbyWabaId(wabaId: string) {
    const params = new HttpParams().set('wabaId', wabaId);
    return this.http.get<any>(`${environment.url}/template-management/templates/get-all-templates-by-wba_id`, { params });
  }

  uploadFile(file: File, formData: any) {
    const formDataToSend = new FormData();

    formDataToSend.append('image', file);
    formDataToSend.append('data', JSON.stringify(formData));

    return this.http.post<UploadResponse>(`${environment.url}/multimedia/resource-management/upload-image`, formDataToSend);
  }

  //inbox chats and messages chat
  getInboxConversations(uuid: string, kcId: string): Observable<any> {
    const params = new HttpParams()
      .set('uuid', uuid)
      .set('kcId', kcId);
    return this.http.get<any>(`${environment.url}/conversation-management/conversation`, { params });
  }

  getMessages(originConversationId: number, lastMessageId: number, waitingByAgentId?: number, waitingByWorkgroupId?: number): Observable<any> {
    let url = `${environment.url}/conversation-management/conversation/${originConversationId}/${lastMessageId}/messages`;
    let params = new HttpParams();

    if (waitingByAgentId) {
        params = params.set('waitingByAgentId', waitingByAgentId.toString());
    } else if (waitingByWorkgroupId) {
        params = params.set('waitingByWorkgroupId', waitingByWorkgroupId.toString());
    }

    return this.http.get(url, { params });
}

  closeChat(data: { kcId: string, msidn: string }) {
    let kcId = data.kcId;
    let phone = data.msidn;
    return this.http.post<any>(`${environment.url}/conversation-management/conversation/${kcId}/${phone}/messages/endConversation`, {});
  }

  getWorkGroupsByAccount(): Observable<WorkGroup[]> {
    const kcId = sessionStorage.getItem("kcUserId");

    const url = `${environment.url}/workgroup-management/get-account-workgroups-list`;
    const params = new HttpParams().set('kcId', kcId);

    return this.http.get<WorkGroup[]>(url, { params });
  }

  transferChatToWorkGroup(data) {
    return this.http.post<any>(`${environment.url}/conversation-management/conversation/assignConversationToGroup/messages`, data);
  }

  getWorkgroupDefault(): Observable<any> {
    const kcId = sessionStorage.getItem("kcUserId");
    const params = new HttpParams().set('KcId', kcId);

    return this.http.get<any>(`${environment.url}/conversation-management/conversation/get-WorkgroupDefault`, { params });
  }

  getOrdersAccepted(accountUUID: string, client?: string): Observable<any[]> {
    let url = `${environment.url}/order-management/order/get-orders-accepted-by-account-uuid?accountUUID=${accountUUID}`;

    if (client) {
      url += `&client=${client}`;
    }

    return this.http.get<any[]>(url).pipe(
      tap(response => console.log('Fetched accepted orders:', response)),
      catchError(error => {
        console.error('Error fetching accepted orders:', error);
        return of([]);
      })
    );
  }

  getOrdersWithStatus(accountUUID: string, client?: string, statusIds?: string[]): Observable<any> {
    const url = `${environment.url}/order-management/order/get-orders-by-account-uuid-and-status?accountUUID=${accountUUID}&client=${client}&statusId=${statusIds}`;
    return this.http.get<any>(url);
  }

  createPaymentLink(orderPaymentLink: any): Observable<any> {
    let url = `${environment.url}/order-management/order/generate-payment-link`;

    return this.http.post<any>(url, orderPaymentLink);
  }

}
